import { render, staticRenderFns } from "./ExpedientInsurersComponent.vue?vue&type=template&id=89067b98&scoped=true"
import script from "./ExpedientInsurersComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExpedientInsurersComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ExpedientInsurersComponent.vue?vue&type=style&index=0&id=89067b98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89067b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89067b98')) {
      api.createRecord('89067b98', component.options)
    } else {
      api.reload('89067b98', component.options)
    }
    module.hot.accept("./ExpedientInsurersComponent.vue?vue&type=template&id=89067b98&scoped=true", function () {
      api.rerender('89067b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/expedients/ExpedientInsurers/ExpedientInsurersComponent.vue"
export default component.exports